import React from "react";
import "./styles.css";
import { ReactComponent as PlaySVG } from "../../assets/play.svg";
import { ReactComponent as PauseSVG } from "../../assets/pause.svg";
import { useAudio } from "../context/audio";
import { usePlayer } from "../context/player";

export default function PlayerUI() {
  
  const {audio, setAudio} = useAudio();
  const {player} = usePlayer();

  return (
    <main className="main">
      <div className="player">
        <img src={audio.thumbNail} alt="Imagem da música" />
        <h2 className="music-title">{audio.title}</h2>

        <div className="progress">
          <div className="progress-bar">
            <div style={{ width: `49%` }}></div>
          </div>
          <div className="progress-time">
            <span>{audio.currentTime}</span>
            <span>{audio.duration}</span>
          </div>
        </div>

        <button
          className="play-button"
          onClick={() => {
            setAudio({ ...audio, isPaused: !audio.isPaused });
            if (audio.isPaused) {
              player.playVideo();
            } else {
              player.pauseVideo();
            }
          }}
        >
          {audio.isPaused ? (
            <PlaySVG className="play-svg" />
          ) : (
            <PauseSVG className="play-svg" />
          )}
        </button>
      </div>
    </main>
  );
}
